<template>
  <div id="listWidget" class="mb-4">
    <div>
      <h4 class="mb-3">온도조절기 예약</h4>
    </div>

    <hr class="mb-3" />

    <div class="temp-schedule-list mb-3" v-if="visibleSchedules.length > 0">
      <div
        class="list-group card-item mb-2"
        style="border-radius: 1.2rem;"
        v-for="{ schedule, index } in visibleSchedules"
        :key="schedule._id"
        v-touch:hold="onTouchHold"
        @click="onUpdateScheduleClick(schedule, index)"
      >
        <div class="list-group-item d-flex align-items-center schedule-card-row">
          <div class="flex-fill ms-3">
            <div class="fw-600" style="font-size: 0.8rem;">{{ scheduleDisplayTitle(index) }}</div>
            <div class="fs-12px text-muted">
              {{ schedule.week.map((item, i) => item ? dayOfWeek[i] : '').join('') }}
            </div>
          </div>
          <div class="me-3">
            <div class="form-check form-switch m-0">
              <input
                class="form-check-input"
                type="checkbox"
                role="switch"
                :checked="schedule.isOn"
                :value="index"
                @click.stop="(e) => onScheduleOnOffChange(e, schedule)"
                v-if="!deleteMode"
              >
              <div v-else @click.stop="onDeleteClick(schedule)">
                <i class="fa-regular fa-trash-can mr-2"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="list-group mt-4" style="border-radius: 1.2rem" v-else>
      <div class="flex-fill">
        <div class="fs-12px text-muted" style="text-align: center;">
          등록된 예약이 없습니다.
        </div>
      </div>
    </div> -->

    <div class="row mt-4">
      <div class="col">
      </div>
      <div class="col">
      </div>
      <div class="col">
        <!-- <button type="button" class="btn btn-primary btn-lg" style="width: 100%" @click="onRegistClick" v-if="!deleteMode">
          등록
        </button>
        <button type="button" class="btn btn-primary btn-lg" style="width: 100%" @click="onDeleteCompleteClick" v-else>
          완료
        </button> -->
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRoute, useRouter } from 'vue-router';
import { ref, reactive, getCurrentInstance, computed, onBeforeMount } from 'vue';
import { useStore } from 'vuex';
import { MQTTTempCommand } from '@/common/constants';
import useMqttControl from '@/common/hooks/useMqttControl';
import Axios, { ScheduleApi } from '@/api';
import moment from 'moment';
import { buildTimerGroupMqttPayload, weekToDaysMask } from '@/common/utils/scheduleMqtt';

const route = useRoute();
const router = useRouter();
const mqttControl = reactive(useMqttControl());
const { emitter } = getCurrentInstance().appContext.config.globalProperties;
const store = useStore();
const schedules = ref([]);
const dayOfWeek = ['일', '월', '화', '수', '목', '금', '토'];
const deleteMode = ref(false);

/** 0,1=난방예약 / 2=냉방예약 (보드 TimerGroup 1~3 과 동일) */
const scheduleDisplayTitle = (index) => {
  if (index === 0) return '난방예약 1';
  if (index === 1) return '난방예약 2';
  if (index === 2) return '냉방예약';
  return `예약 ${index + 1}`;
};

const zone = computed(() => {
  if (store.state.home.zones.length > 0) {
    return store.getters['home/getCurrentZone'];
  } else return null;
});
const group = computed(() => {
  return zone.value.groups.find((g) => g._id == route.params.groupId);
});
const device = computed(() => {
  return group.value ? group.value.devices.find(device => device._id == route.params.deviceId) : undefined;
});
/** hcMode 1=냉방(에어컨), 그 외=난방 */
const isCoolingMode = computed(() => device.value?.item?.hcMode === 1);
/** 난방: 예약1·2만, 냉방: 예약3만 (원본 index 유지) */
const visibleSchedules = computed(() =>
  schedules.value
    .map((schedule, index) => ({ schedule, index }))
    .filter(({ index }) => (isCoolingMode.value ? index === 2 : index < 2))
);
const allDevices = computed(() => {
  const devices = [];
  zone.value.groups.forEach(group => {
    group.devices.forEach(device => {
      if (device.type == 2) { // 온도조절기
        devices.push(device);
      }
    });
  });
  return devices;
});

onBeforeMount(() => {
  requestSchedules();
})

const onRegistClick = () => {
  router.push(`/settings/temp/schedule/${group.value._id}/${device.value._id}/regist`);
}

const initSchedules = async () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = now.getMonth();
  const day = now.getDate();

  const params = {
    title: "예약",
    deviceId: route.params.deviceId,
    week: [1, 1, 1, 1, 1, 1, 1],
    data: Array.from({ length: 12 }).map((_, i) => ({
      id: i + 1,
      start: moment(new Date(year, month, day, i * 2, 0, 0)).format("HH:mm"),
      end: i == 11 ? "24:00" : moment(new Date(year, month, day, (i + 1) * 2, 0, 0)).format("HH:mm"),
      temp: 18.0,
      pattern: 0,
      enabled: true,
    }))
  };
    
  const mqttPayload = buildTimerGroupMqttPayload({
    enable: 0,
    days: "SMTWTFS",
    data: params.data,
  });
  
  console.log(params)
  console.log(mqttPayload)

  const result = await Promise.all(Array.from({ length: 3 }).map(async (_, i) => {
    await requestRegistSchedule({
      ...params,
      title: params.title
    });
    mqttControl.onPublishTemp(device.value.controllerId, MQTTTempCommand.SyncTimerGroup + `${i + 1}`, mqttPayload);
  }));
  requestSchedules(false)
}

const requestRegistSchedule = async (params) => {
  try {
    const result = await Axios.post(ScheduleApi.REGIST_SCHEDULE, params);
    console.log(result)
    if (result.resultCode === '0000') {
    } else {
      console.warn(result.resultMessage);
    }
  } catch (error) {
    console.log(error);
  }
}

const requestSchedules = async (init = true) => {
  return new Promise(async (resolve, reject) => {
    try {
      const result = await Axios.get(ScheduleApi.SCHEDULES, { deviceId: route.params.deviceId });
      if (result.resultCode === '0000') {
        console.log(result.resultData);
        if (result.resultData?.length > 0) {
          schedules.value = result.resultData;
        } else if (init) {
          initSchedules();
        }
        resolve();
      } else {
        console.warn(result.resultMessage);
        if (!init) {
          emitter.emit('showPopAlert', {
            description: result.resultMessage,
          });
        }
        reject();
      }
    } catch (error) {
      console.log(error);
      if (!init) {
        emitter.emit('showPopAlert', {
          description: "예약목록 조회에 실패했습니다.",
        });
      }
      reject();
    }
  });
}

const requestUpdateSchedule = async (id, params, e) => {
  return new Promise(async (resolve, reject) => {
    try {
      const result = await Axios.patch(ScheduleApi.UPDATE_SCHEDULE.replace(":id", id), params);
      if (result.resultCode === '0000') {
        console.log(result);
        schedules.value.forEach((schedule) => {
          if (schedule._id == id) {
            schedule.isOn = params.isOn;
          } else {
            // schedule.isOn = false;
          }
        });
        resolve(result.resultData);
      } else {
        console.warn(result.resultMessage);
        emitter.emit('showPopAlert', {
          description: result.resultMessage,
        });
        reject(result.resultMessage);
      }
    } catch (error) {
      console.log(error);
      emitter.emit('showPopAlert', {
        description: "예약 On/Off에 실패했습니다.",
      });
      reject("예약 On/Off에 실패했습니다.");
    }
  });
};

const requestDeleteSchedule = async (id) => {
  try {
    const result = await Axios.delete(ScheduleApi.DELETE_SCHEDULE.replace(":id", id));
    if (result.resultCode === '0000') {
      const index = schedules.value.findIndex(item => item._id == id);
      if (index >= 0) {
        schedules.value.splice(index, 1);
      }
    } else {
      console.warn(result.resultMessage);
      emitter.emit('showPopAlert', {
        description: result.resultMessage,
      });
    }
  } catch (error) {
    console.log(error);
    emitter.emit('showPopAlert', {
      description: "예약 삭제에 실패했습니다.",
    });
  }
}

const onScheduleOnOffChange = async (e, schedule) => {
  const index = parseInt(e.target.value) + 1;
  const nextOn = !schedule.isOn;
  mqttControl.onPublishTemp(device.value.controllerId, MQTTTempCommand.TimerGroupEnable + `${index}`, nextOn ? '1' : '0');
  // Enable 후 슬롯별 arm 재적용
  const mqttPayload = buildTimerGroupMqttPayload({
    enable: nextOn ? 1 : 0,
    days: weekToDaysMask(schedule.week),
    data: schedule.data,
  });
  mqttControl.onPublishTemp(device.value.controllerId, MQTTTempCommand.SyncTimerGroup + `${index}`, mqttPayload);
  await requestUpdateSchedule(schedule._id, { isOn: nextOn }, e);

  if (device.value.item.allowSync) {
    await updateSyncSchedules();
  }
}

const updateSyncSchedules = async () => {
  const schedules = await requestZoneSchedules();
  const srcSchedules = schedules.filter(schedule => schedule.deviceId == route.params.deviceId);
  const tarSchedules = schedules.filter(schedule => schedule.deviceId != route.params.deviceId);

  if (srcSchedules.length == 0 || tarSchedules.length == 0) {
    console.warn("동기화할 예약이 없습니다.");
    return new Promise((resolve, reject) => {
      resolve();
    });
  }

  tarSchedules.forEach((schedule, i) => {
    const index = (i % 3);
    const device = allDevices.value.find(device => device._id == schedule.deviceId);
    if (!device) {
      console.warn(`장치가 존재하지 않습니다. deviceId: ${schedule.deviceId}`);
      return;
    } else {
      const mqttPayload = buildTimerGroupMqttPayload({
        enable: srcSchedules[index].isOn ? 1 : 0,
        days: weekToDaysMask(srcSchedules[index].week),
        data: srcSchedules[index].data,
      });
      mqttControl.onPublishTemp(device.controllerId, MQTTTempCommand.TimerGroupEnable + `${index + 1}`, srcSchedules[index].isOn ? '1' : '0');
      mqttControl.onPublishTemp(device.controllerId, MQTTTempCommand.SyncTimerGroup + `${index + 1}`, mqttPayload);
    }
  });
  
  return requestSyncSchedules({
    srcIds: srcSchedules.map(schedule => schedule._id),
    tarIds: tarSchedules.map(schedule => schedule._id)
  })
}

const requestSyncSchedules = async (params) => {
  return new Promise(async (resolve, reject) => {
    try {
      const result = await Axios.post(ScheduleApi.SYNC_SCHEDULES, params);
      if (result.resultCode === '0000') {
        console.log(result.resultData);
        resolve(result.resultData);
      } else {
        console.warn(result.resultMessage);
        reject(result.resultMessage);
      }
    } catch (error) {
      console.log(error);
      reject("예약목록 동기화에 실패했습니다.");
    }
  });
};

const requestZoneSchedules = async () => {
  return new Promise(async (resolve, reject) => {
    try {
      const result = await Axios.get(ScheduleApi.SCHEDULES_ALL, { zoneId: zone.value._id, isSync: true });
      if (result.resultCode === '0000') {
        // console.log(result.resultData[0].deviceId)
        resolve(result.resultData);
      } else {
        console.warn(result.resultMessage);
        reject(result.resultMessage);
      }
    } catch (error) {
      console.log(error);
      reject("예약목록 조회에 실패했습니다.");
    }
  });
};

const onTouchHold = () => {
  // deleteMode.value = true;
}

const onDeleteClick = (schedule) => {
  emitter.emit('showPopConfirm', {
    description: "예약을 삭제하시겠습니까?",
    okCallback: () => requestDeleteSchedule(schedule._id)
  });
}

const onDeleteCompleteClick = () => {
  deleteMode.value = false;
}

const onUpdateScheduleClick = (schedule, index) => {
  router.push(`/settings/temp/schedule/${group.value._id}/${device.value._id}/${schedule._id}/${index + 1}/update`);
}
</script>

<style scoped>
.temp-schedule-list {
  background: transparent;
}

.schedule-card-row {
  height: 4rem;
  padding: 2px 0;
  border: none;
  background: #ffffff;
  border-radius: 1.2rem;
}
</style>
